import { useEffect, useState } from "react";
import useAnalyticsService from "../../services/AnalyticsService";
import { AggregatedAnalyticsSummary } from "../../types/Analytics";
import LoadingEllipsis from "../LoadingEllipsis";
import Ghost from "../Ghost";

export default function AdminAnalyticsSummary() {
  const { getAggregatedExperienceSummary } = useAnalyticsService();

  const [summaryData, setSummaryData] =
    useState<AggregatedAnalyticsSummary | null>(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getAggregatedExperienceSummary()
      .then((data) => {
        setSummaryData(data);
      })
      .catch((error) => {
        console.error("Error fetching aggregated analytics summary:", error);
        setSummaryData(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
    }, []);


  if (isLoading) {
    return (
      <>
        <Ghost additionalClasses="rounded h-96" />
      </>
    );
  }

  if (summaryData === null) {
    return (
      <>
        <p>No data found</p>
      </>
    );
  }

  return (
    <div className="card p-4 mt-4">
      <h3 className="text-xl">Sessions</h3>
      <dl className="grid grid-cols-2 xl:grid-cols-3 gap-4">
        <div>
          <dt className="text-sm font-medium text-gray-300">Last hour</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast1Hour}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 24 hours</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast24Hours}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 7 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast7Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 30 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast30Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 60 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast60Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 90 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.streamingSessionsCountInLast90Days}
          </dd>
        </div>
      </dl>
      <hr className="my-4" />
      <h3 className="text-xl">Local recordings</h3>
      <dl className="grid grid-cols-2 xl:grid-cols-3 gap-4">
        <div>
          <dt className="text-sm font-medium text-gray-300">Last hour</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast1Hour}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 24 hours</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast24Hours}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 7 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast7Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 30 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast30Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 60 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast60Days}
          </dd>
        </div>
        <div>
          <dt className="text-sm font-medium text-gray-300">Last 90 days</dt>
          <dd className="mt-1 text-lg font-semibold text-gray-100">
            {summaryData.localRecordingsCountInLast90Days}
          </dd>
        </div>
      </dl>
    </div>
  );
}
